import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    thyroidData: [],
    activeName: '健康总评',
    activeName1: '营养状态'
  },
  mutations: {
    updateThyroidData(state, thyroidData) {
      state.thyroidData = thyroidData;
    },
    changeActiveName(state, key) {
      state.activeName = key
    },
    changeActiveName1(state, key) {
      state.activeName1 = key
    },
  },
  actions: {
    updateThyroidDataAct({ commit }, thyroidData) {
      commit('updateThyroidData', thyroidData);
    },
  },
  modules: {
  }
})
